import { render } from "./LevelPage.vue?vue&type=template&id=3a9242d3&ts=true"
import script from "./LevelPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./LevelPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/level/LevelPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a9242d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a9242d3', __exports__)) {
    api.reload('3a9242d3', __exports__)
  }
  
  module.hot.accept("./LevelPage.vue?vue&type=template&id=3a9242d3&ts=true", () => {
    api.rerender('3a9242d3', render)
  })

}


export default __exports__